/**
 * Menu dismiss:
 *
 * Closes open details menus marked [data-menu-details] on an outside
 * pointerdown, and when a [role=menuitem] inside the menu is chosen
 * (needed for download links that do not navigate away).
 * Used by header `app_dropdown` (Account / Export), `app_pill_dropdown`, and the
 * dashboard row kebab — styling and item actions stay in those components.
 */

function closeMenusOnOutsidePointer(event) {
  const target = event.target;
  if (!(target instanceof Node)) return;
  document.querySelectorAll("[data-menu-details][open]").forEach((details) => {
    if (details.contains(target) || isInlineFormatMenu(details)) return;
    details.open = false;
  });
}

/** Full editing bar keeps this details open; only the collapsed pane menu dismisses. */
function isInlineFormatMenu(details) {
  if (!details.hasAttribute("data-tiptap-format-menu")) return false;
  const editor = details.closest("#project-editor");
  return editor?.dataset.documentEditing === "true" && editor.dataset.editorView === "edit";
}

function closeMenuOnItemClick(event) {
  const item = event.target instanceof Element ? event.target.closest("[role='menuitem']") : null;
  const details = item?.closest("[data-menu-details]");
  if (details) details.open = false;
}

document.addEventListener("pointerdown", closeMenusOnOutsidePointer);
document.addEventListener("click", closeMenuOnItemClick);
